let currentHighlight = -1;
let highlights = [];
const block = document.querySelector('[data-js-long-leak]');
const input = document.querySelector('[data-js-leak-search-input]') as HTMLInputElement;
const div = document.querySelector('[data-js-leak-content-div]');
const matchCount = document.querySelector('[data-js-leak-match-count]');
const matchCountText = document.querySelector('[data-js-leak-match-count-text]');
const searchButton = document.querySelector('[data-js-leak-search-button]') as HTMLButtonElement;
const clearSearchButton = document.querySelector('[data-js-leak-clear-search-button]');
const nextButton = document.querySelector('[data-js-leak-next-highlight-button]');

function nextHighlighted() {
    if (highlights.length === 0) {
        return;
    }

    const scrollOffset = window.innerWidth > 1080 ? 180 : 230;

    currentHighlight = (currentHighlight + 1) % highlights.length;

    // @ts-ignore
    // eslint-disable-next-line max-len
    highlights[currentHighlight].parentNode.scrollTop = highlights[currentHighlight].offsetTop - scrollOffset;

    highlights.forEach((el) => {
        // @ts-ignore
        el.classList.remove('long-leak__item_highlight_current');
    });

    // @ts-ignore
    highlights[currentHighlight].classList.add('long-leak__item_highlight_current');
}

function searchText() {
    // @ts-ignore
    const filter = input?.value.toUpperCase();
    const text = div?.getElementsByTagName('li');
    let i;
    let txtValue = '';

    if (filter.length < 3) {
        return;
    }

    highlights = [];
    currentHighlight = -1;

    if (text) {
        // eslint-disable-next-line no-plusplus
        for (i = 0; i < text.length; i++) {
            txtValue = text[i].textContent || text[i].innerText;

            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                text[i].classList.add('long-leak__item_highlight');
                // @ts-ignore
                highlights.push(text[i]);
            } else {
                text[i].classList.remove('long-leak__item_highlight');
            }
        }
    }

    // @ts-ignore
    matchCountText.innerText = `${highlights.length} matches found`;
    matchCount?.classList.remove('long-leak__match-count_none');

    if (highlights.length > 0) {
        nextHighlighted(); // Scroll to the first match
    }
}

function clearSearch() {
    const highlightedText = div?.querySelectorAll('.long-leak__item_highlight');
    let i;

    if (highlightedText) {
        // eslint-disable-next-line no-plusplus
        for (i = 0; i < highlightedText.length; i++) {
            highlightedText[i].classList.remove('long-leak__item_highlight');
            highlightedText[i].classList.remove('long-leak__item_highlight_current');
        }
    }

    input.value = '';

    // @ts-ignore
    matchCountText.innerText = '';
    highlights = [];
    currentHighlight = -1;
    matchCount?.classList.add('long-leak__match-count_none');
}

window.addEventListener('load', () => {
    searchButton?.addEventListener('click', () => {
        searchText();
    });

    clearSearchButton?.addEventListener('click', () => {
        clearSearch();
    });

    nextButton?.addEventListener('click', () => {
        block?.scrollIntoView();
        nextHighlighted();
    });

    input?.addEventListener('keyup', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            block?.scrollIntoView();
            searchText();
        }
    });
});

export { };
